import { createContext, ReactNode, useContext, useMemo } from 'react'
import { Betriebsstellenart } from '../types'

export interface BetriebsstelleSearchAPI {
  getBetriebsstellenSearch: (
    query: string,
    types?: Betriebsstellenart[],
    signal?: AbortSignal
  ) => Promise<Array<{ rl100Langname: string }>>
  isBetriebsstellenApiEnabled: () => boolean
  isCancel: (error: unknown) => boolean
}

interface BetriebsstelleSearchContextType {
  searchAPI?: BetriebsstelleSearchAPI
}

const BetriebsstelleSearchContext =
  createContext<BetriebsstelleSearchContextType>({})

interface BetriebsstelleSearchProviderProps {
  children: ReactNode
  searchAPI?: BetriebsstelleSearchAPI
}

export function BetriebsstelleSearchProvider({
  children,
  searchAPI
}: Readonly<BetriebsstelleSearchProviderProps>) {
  const value = useMemo(() => ({ searchAPI }), [searchAPI])

  return (
    <BetriebsstelleSearchContext.Provider value={value}>
      {children}
    </BetriebsstelleSearchContext.Provider>
  )
}

export function useBetriebsstelleSearchContext() {
  return useContext(BetriebsstelleSearchContext)
}
